import { lazy } from 'react';

export const ModalSearchAsync = lazy(() => import('./modalSearch'));
